import { Link } from "react-router-dom";
import ThumbnailAsset from "components/common/assets/ThumbnailAsset";

const ProjectTitleDetailed = (props) => {
    const textColorClass = "text-" + props.project.color + "-500"
    return (
        <Link
            to={"/projects/" + props.project.code}
            key={props.project.code}
        >

            {/* Following is the mobile version of the project titles */}
            <div
                className="block md:hidden justify-between w-full overflow-hidden mb-1"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-offset="10"
            >
                <div>
                    <p className={`text-[1.6rem] font-semibold mb-2 px-1 ${textColorClass}`}>[{props.project.name}]</p>
                    <ThumbnailAsset asset={props.project.thumbnail} assetStyles="w-[calc(32*0.8rem)] h-[calc(17*0.8rem)] object-cover mb-3" />
                    <p className="text-[1.07rem] px-1">{props.project.description.substring(0, 200)}...</p>
                </div>

                {/* This is the actual resolution of the thumbnails */}

            </div>

            {/* Following is the desktop version of the project titles */}
            <div
                className="hidden md:flex justify-between w-full overflow-hidden mb-1 px-20"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-offset="10"
            >
                <div className="max-w-[50%] flex flex-col justify-center pb-3">
                    <p className={`text-[1.6rem] font-semibold ${textColorClass}`}>[{props.project.name}]</p>
                    <p className="text-[1.07rem] mt-5">{props.project.description}</p>
                </div>

                {/* This is the actual resolution of the thumbnails */}
                <ThumbnailAsset asset={props.project.thumbnail} assetStyles="w-[calc(32*0.8rem)] h-[calc(20*0.8rem)] object-cover" />

            </div>
        </Link>
    )
}

export default ProjectTitleDetailed;